<i18n
  src="@/locales/views/organization/projections/query_estimated_harvest/list_harvest_processes.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">
      {{ module_name }}
    </h1>
  </div>

  <div
    v-if="load_data_general"
    class="bg-white shadow overflow-hidden sm:rounded-md"
  >
    <ul role="list" class="divide-y divide-gray-200">
      <li
        v-for="harvest_process in harvest_processes"
        :key="harvest_process.id"
      >
        <div
          class="block hover:bg-gray-50 cursor-pointer"
          @click.prevent="goToShowHarvestProcess(harvest_process.id)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ harvest_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible"
                  ><i class="fa-solid fa-eye"></i
                  ><span class="space-icon"></span
                  >{{ $t("labels.show_link") }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <loading-message v-else />
</template>

<script>
import BasicContainerExportLPRequester from "@/views/organization/requesters/projections/query_estimated_harvest/list_harvest_processes.js";

export default {
  name: "OrgProjectionsQueryEstimatedHarvestListHarvestProcesses",
  props: ["organization_id"],
  data() {
    return {
      load_data_general: false,
      harvest_processes: []
    };
  },
  methods: {
    fetchHarvestProcesses: async function () {
      let response =
        await BasicContainerExportLPRequester.fetchHarvestProcesses(
          this.organization_id
        );
      this.harvest_processes = response.data;
      this.load_data_general = true;
    },
    goToShowHarvestProcess: function (harvest_process_id) {
      this.$router.push({
        name: this.routeName("show_harvest_process"),
        params: {
          harvest_process_id: harvest_process_id,
          organization_id: this.organization_id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.fetchHarvestProcesses())
    );
  }
};
</script>
